import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { Base as Layout } from '~/layouts/';
import { LangSwitch } from '~/components';
import { live as liveRoute } from '~/views/routes';

const childRoutes = Object.values(liveRoute);

@inject('app')
@observer
class Live extends Component {
  render() {
    const { app } = this.props;
    const { locale, changeLanguageTo } = app;

    return (
      <Layout
        lang={
          <LangSwitch locale={locale} changeLanguageTo={changeLanguageTo} />
        }
      >
        <Helmet>
          <title>Live Streaming - Insta360</title>
        </Helmet>
        <Switch>
          {childRoutes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                component={route.component}
                exactly={route.exactly}
              />
            );
          })}
        </Switch>
      </Layout>
    );
  }
}

export default Live;



// WEBPACK FOOTER //
// ./src/container/live.js